import Dashboard from "./HRMS/Dashboard/Dashboard";
import Users from "./HRMS/Users/Users";
import RecentPay from "./HRMS/Payments/ResentPay.js";
import Login from "./Authentication/login";
import StaffList from "./Staff/StaffList.js";
import AddStaff from "./Staff/AddStaff.js";
import EditStaff from "./Staff/EditStaff.js";
import ViewStaff from "./Staff/ViewStaff.js";
import AddAdmin from "./Admin/AddAdmin.js";
import EditAdmin from "./Admin/EditAdmin.js";
import OrdersList from "./Orders/OrdersList.js";
import ProductList from "./product/ProductList.js";
import AddProductStepper from "./product/AddProductStepper.js";
import AddStock from "./product/AddStock.js";
import StockAdjust from "./product/StockAdjust.js";
import EditProduct from "./product/EditProduct";
import ProductView from "./product/ProductView";
import CategoryList from "./category/CategoryList.js";
import CategoryView from "./category/CategoryView";
import AddCategory from "./category/Addcategory.js";
import EditCategory from "./category/EditCategory.js";
import MenuList from "./menu/MenuList.js";
import AddMenu from "./menu/AddMenu.js";
import EditMenu from "./menu/EditMenu.js";
import ViewMenu from "./menu/ViewMenu.js";
import EditTax from "./Tax/EditTax.js";
import AddTax from "./Tax/AddTax.js";
import TaxList from "./Tax/TaxList.js";
import ViewTax from "./Tax/ViewTax.js";
import DeleteTax from "./Tax/DeleteTax.js";
import SizeList from "./Options/Size/Sizelist.js";
import AddSize from "./Options/Size/AddSize.js";
import EditSize from "./Options/Size/EditSize.js";
import SizeView from "./Options/Size/ViewSize.js";
import MaterialList from "./Options/Material/MaterialList.js";
import AddMaterial from "./Options/Material/AddMaterial.js";
import EditMaterial from "./Options/Material/EditMaterial.js";
import MaterialView from "./Options/Material/ViewMaterial.js";
import TestimonialList from "./Testimonials/TestimonialList.js";
import FontList from "./Options/Font/FontList.js";
import FontView from "./Options/Font/FontView.js";
import AddFont from "./Options/Font/AddFont.js";
import EditFont from "./Options/Font/EditFont.js";
import ColorList from "./Options/color/ColorList.js";
import ColorView from "./Options/color/ColorView.js";
import AddColor from "./Options/color/AddColor.js";
import EditColor from "./Options/color/EditColor.js";
import UserView from "./HRMS/Users/UserView.js";
import AddCoupon from "./coupons/AddCoupons.js";
import EditCoupon from "./coupons/EditCoupons.js";
import ViewCoupon from "./coupons/ViewCoupons.js";
import CouponsList from "./coupons/CouponsList.js";
import BulkorderList from "./Bulkorder/BulkorderList";
import BulkorderView from "./Bulkorder/BulkorderView";
import ContactUsList from "./ContactUs/ContactUsList.js";
import DeliveredOrders from "./Orders/DeliveredOrders.js";
import ApprovedTestimonials from "./Testimonials/ApprovedTestimonials.js";
import ImportProducts from "./product/ImportProducts.js";
import OrderView from "./Orders/OrderView.js";
import Profile from "./Authentication/Profile.js";
import Blog from "./Blog/Blog.js";
import BlogView from "./Blog/BlogView.js";
import BlogCategory from "./BlogCategory/BlogCategoryList.js";
import BlogCategoryView from "./BlogCategory/BlogCategoryView.js";
import BlogAdd from "./Blog/BlogAdd.js";
import BlogEdit from "./Blog/BlogEdit.js";
import BlogCategoryadd from "./BlogCategory/BlogCategoryadd.js";
import BlogCategoryedit from "./BlogCategory/BlogCategoryedit.js";
import DesignForm from "./Orders/DesignForm.js";
import PostTemplatesList from "./PostTemplates/PostTemplatesList.js";
import AddPostTemplate from "./PostTemplates/AddPostTemplate";
import EditPostTemplate from "./PostTemplates/EditPostTemplate";
import RoleList from "./Role/RoleList.js";
import RoleForm from "./Role/RoleForm.js";
import RoleView from "./Role/RoleView.js";
import StaffForm from "./Staff/StaffForm.js";
import ProfitLossReport from "./reports/ProfitLossReport";
import TaxReport from "./reports/TaxReport";
import PaymentGatewayReport from "./reports/PaymentGatewayReport";
import CourierReport from "./reports/CourierReport";
import InvoiceSettings from "./Settings/InvoiceSettings";
import SiteSettings from "./Settings/SiteSettings";

const routeDefinitions = [
  {
    path: "/settings",
    name: "settings",
    exact: true,
    pageTitle: "Invoice Settings",
    component: InvoiceSettings,
  },
  {
    path: "/site-settings",
    name: "site-settings",
    exact: true,
    pageTitle: "Site Settings",
    component: SiteSettings,
  },
  {
    path: "/",
    name: "dashboard",
    exact: true,
    pageTitle: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/users",
    name: "users",
    exact: true,
    pageTitle: "Users",
    component: Users,
  },
  {
    path: "/recent-pay",
    name: "recentpay",
    exact: true,
    pageTitle: "Recent Payments",
    component: RecentPay,
  },
  {
    path: "/login",
    name: "login",
    exact: true,
    pageTitle: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "profile",
    exact: true,
    pageTitle: "My Profile",
    component: Profile,
  },
  {
    path: "/staff",
    name: "stafflist",
    exact: true,
    pageTitle: "Staff List",
    component: StaffList,
  },
  {
    path: "/staff/add",
    name: "staffadd",
    exact: true,
    pageTitle: "Add Staff",
    component: AddStaff,
  },
  {
    path: "/staff/edit",
    name: "staffedit",
    exact: true,
    pageTitle: "Edit Staff",
    component: EditStaff,
  },
  {
    path: "/staff/edit/:staffId",
    name: "staffeditbyid",
    exact: true,
    pageTitle: "Edit Staff",
    component: EditStaff,
  },
  {
    path: "/staff/view/:staffId",
    name: "staffview",
    exact: true,
    pageTitle: "View Staff",
    component: ViewStaff,
  },
  {
    path: "/addAdmin",
    name: "addadmin",
    exact: true,
    pageTitle: "Add Admin",
    component: AddAdmin,
  },
  {
    path: "/admin/edit",
    name: "adminedit",
    exact: true,
    pageTitle: "Edit Admin",
    component: EditAdmin,
  },
  {
    path: "/Contact-list",
    name: "ContactList",
    exact: true,
    pageTitle: "Contact List",
    component: ContactUsList,
  },
  {
    path: "/orders-list",
    name: "orderslist",
    exact: true,
    pageTitle: "Orders List",
    component: OrdersList,
  },
  {
    path: "/delivered",
    name: "deliveredlist",
    exact: true,
    pageTitle: "Delivered List",
    component: DeliveredOrders,
  },
  {
    path: "/categories",
    name: "categories",
    exact: true,
    pageTitle: "Category List",
    component: CategoryList,
  },
  {
    path: "/category/add",
    name: "categoryadd",
    exact: true,
    pageTitle: "Add Category",
    component: AddCategory,
  },
  {
    path: "/category/edit/:slug",
    name: "categoryedit",
    exact: true,
    pageTitle: "Edit Category",
    component: EditCategory,
  },
  {
    path: "/category/view/:slug",
    name: "categoryview",
    exact: true,
    pageTitle: "Category View",
    component: CategoryView,
  },
  {
    path: "/products",
    name: "products",
    exact: true,
    pageTitle: "Product List",
    component: ProductList,
  },
  {
    path: "/product/stock-adjust",
    name: "productstockadjust",
    exact: true,
    pageTitle: "Stock Adjust",
    component: StockAdjust,
  },
  {
    path: "/product/add-stock",
    name: "productstockadd",
    exact: true,
    pageTitle: "Add Stock",
    component: AddStock,
  },
  {
    path: "/product/add",
    name: "productadd",
    exact: true,
    pageTitle: "Add Product",
    component: AddProductStepper,
  },
  {
    path: "/product/edit/:slug",
    name: "productedit",
    exact: true,
    pageTitle: "Edit Product",
    component: EditProduct,
  },
  {
    path: "/product/view/:slug",
    name: "productview",
    exact: true,
    pageTitle: "Product View",
    component: ProductView,
  },
  {
    path: "/menu",
    name: "MenuList",
    exact: true,
    pageTitle: "Menu List",
    component: MenuList,
  },
  {
    path: "/menu/add",
    name: "MenuAdd",
    exact: true,
    pageTitle: "Add Menu",
    component: AddMenu,
  },
  {
    path: "/menu/edit/:id",
    name: "MenuEdit",
    exact: true,
    pageTitle: "Edit Menu",
    component: EditMenu,
  },
  {
    path: "/menu/view/:id",
    name: "Menuview",
    exact: true,
    pageTitle: "Menu View",
    component: ViewMenu,
  },
  {
    path: "/tax/edit",
    name: "EditTax",
    exact: true,
    pageTitle: "Edit Tax",
    component: EditTax,
  },
  {
    path: "/tax/view/:id",
    name: "ViewTax",
    exact: true,
    pageTitle: "View Tax",
    component: ViewTax,
  },
  {
    path: "/tax",
    name: "TaxList",
    exact: true,
    pageTitle: "Tax List",
    component: TaxList,
  },
  {
    path: "/tax/add",
    name: "TaxAdd",
    exact: true,
    pageTitle: "Add Tax",
    component: AddTax,
  },

  {
    path: "/tax/delete",
    name: "DeleteTax",
    exact: true,
    pageTitle: "Delete Tax",
    component: DeleteTax,
  },
  {
    path: "/size",
    name: "Size",
    exact: true,
    pageTitle: "Size List",
    component: SizeList,
  },
  {
    path: "/size/add",
    name: "SizeAdd",
    exact: true,
    pageTitle: "Add Size",
    component: AddSize,
  },
  {
    path: "/size/edit/:id",
    name: "SizeEdit",
    exact: true,
    pageTitle: "Edit Size",
    component: EditSize,
  },
  {
    path: "/size/view/:id",
    name: "SizeView",
    exact: true,
    pageTitle: "View Size",
    component: SizeView,
  },
  {
    path: "/material",
    name: "Material",
    exact: true,
    pageTitle: "Material List",
    component: MaterialList,
  },
  {
    path: "/material/add",
    name: "MaterialAdd",
    exact: true,
    pageTitle: "Add Material",
    component: AddMaterial,
  },
  {
    path: "/material/edit/:id",
    name: "MaterialEdit",
    exact: true,
    pageTitle: "Edit Material",
    component: EditMaterial,
  },
  {
    path: "/material/view/:id",
    name: "MaterialView",
    exact: true,
    pageTitle: "View Material",
    component: MaterialView,
  },
  {
    path: "/testimonial",
    name: "TestimonialList",
    exact: true,
    pageTitle: "Testimonial List",
    component: TestimonialList,
  },
  {
    path: "/approvedTestimonial",
    name: "approved Testimonial",
    exact: true,
    pageTitle: "Approved Testimonials",
    component: ApprovedTestimonials,
  },
  {
    path: "/font",
    name: "FontList",
    exact: true,
    pageTitle: "Font List",
    component: FontList,
  },
  {
    path: "/font/view",
    name: "FontView",
    exact: true,
    pageTitle: "Font View",
    component: FontView,
  },

  {
    path: "/font/add",
    name: "FontAdd",
    exact: true,
    pageTitle: "Add Font",
    component: AddFont,
  },
  {
    path: "/font/edit/:id",
    name: "FontEdit",
    exact: true,
    pageTitle: "Edit Font",
    component: EditFont,
  },
  {
    path: "/color",
    name: "ColorList",
    exact: true,
    pageTitle: "Color List",
    component: ColorList,
  },
  {
    path: "/color/edit/:id",
    name: "EditColor",
    exact: true,
    pageTitle: "Edit Color",
    component: EditColor,
  },

  {
    path: "/color/add",
    name: "ColorAdd",
    exact: true,
    pageTitle: "Add Color",
    component: AddColor,
  },
  {
    path: "/color/view/:id",
    name: "ColorView",
    exact: true,
    pageTitle: "Color View",
    component: ColorView,
  },
  {
    path: "/users/admin/view/:id",
    name: "UserView",
    exact: true,
    pageTitle: "User View",
    component: UserView,
  },
  {
    path: "/coupon",
    name: "CouponList",
    exact: true,
    pageTitle: "Coupon List",
    component: CouponsList,
  },
  {
    path: "/coupon/add",
    name: "CouponAdd",
    exact: true,
    pageTitle: "Add Coupon",
    component: AddCoupon,
  },
  {
    path: "/coupon/edit/:id",
    name: "CouponEdit",
    exact: true,
    pageTitle: "Edit Coupon",
    component: EditCoupon,
  },
  {
    path: "/coupon/view/:id",
    name: "CouponView",
    exact: true,
    pageTitle: "View Coupon",
    component: ViewCoupon,
  },
  {
    path: "/bulk-order",
    name: "Bulk order",
    exact: true,
    pageTitle: "Bulk Order List",
    component: BulkorderList,
  },
  {
    path: "/bulk-order/view/",
    name: "Bulk order View",
    exact: true,
    pageTitle: "View Bulk Order",
    component: BulkorderView,
  },
  {
    path: "/product/import",
    name: "Import Products",
    exact: true,
    pageTitle: "Import Products",
    component: ImportProducts,
  },
  {
    path: "/orders/view",
    name: "OrderView",
    exact: true,
    pageTitle: "Order View",
    component: OrderView,
  },
  {
    path: "/blog",
    name: "Blog",
    exact: true,
    pageTitle: "Blog",
    component: Blog,
  },
  {
    path: "/blog/add",
    name: "Blog Add",
    exact: true,
    pageTitle: "Blog Add",
    component: BlogAdd,
  },
  {
    path: "/blog/edit/:id",
    name: "Blog Edit",
    exact: true,
    pageTitle: "Blog Edit",
    component: BlogEdit,
  },
  {
    path: "/blog/view/:slug",
    name: "Blog View",
    exact: true,
    pageTitle: "Blog View",
    component: BlogView,
  },
  {
    path: "/blogcategory",
    name: "Blog Category",
    exact: true,
    pageTitle: "Blog Category",
    component: BlogCategory,
  },
  {
    path: "/blogcategory/view/:slug",
    name: "Blog Category View",
    exact: true,
    pageTitle: "Blog Category View",
    component: BlogCategoryView,
  },
  {
    path: "/blogcategory/add",
    name: "Blog Category Add",
    exact: true,
    pageTitle: "Blog Category Add",
    component: BlogCategoryadd,
  },
  {
    path: "/blogcategory/edit/:id",
    name: "Blog Category Edit",
    exact: true,
    pageTitle: "Blog Category Edit",
    component: BlogCategoryedit,
  },
  {
    path: "/orders/verify",
    name: "Orders Verify",
    exact: true,
    pageTitle: "Verify Order Design",
    component: DesignForm,
  },
  {
    path: "/banner-template",
    name: "Banner Templates",
    exact: true,
    pageTitle: "Banner Templates",
    component: PostTemplatesList,
  },
  {
    path: "/banner-templates/add",
    name: "addBannerTemplate",
    exact: true,
    pageTitle: "Add Banner Template",
    component: AddPostTemplate,
  },
  {
    path: "/banner-templates/edit",
    name: "editBannerTemplate",
    exact: true,
    pageTitle: "Edit Banner Template",
    component: EditPostTemplate,
  },
  {
    path: "/add-banner-template",
    name: "add-banner-template",
    exact: true,
    pageTitle: "Add Banner Template",
    component: AddPostTemplate,
  },
  {
    path: "/role-list",
    name: "role-list",
    exact: true,
    pageTitle: "Role List",
    component: RoleList,
  },
  {
    path: "/role/add",
    name: "role-add",
    exact: true,
    pageTitle: "Add Role",
    component: RoleForm,
  },
  {
    path: "/role-edit/:id",
    name: "role-edit",
    exact: true,
    pageTitle: "Edit Role",
    component: RoleForm,
  },
  {
    path: "/role-view/:id",
    name: "role-view",
    exact: true,
    pageTitle: "View Role",
    component: RoleView,
  },
  {
    path: "/reports/profit",
    component: ProfitLossReport,
    pageTitle: "Profit & Loss",
    permissionKey: "PROFIT AND LOSS",
  },
  {
    path: "/reports/tax",
    component: TaxReport,
    pageTitle: "Tax (GST) Report",
    permissionKey: "TAX REPORT",
  },
  {
    path: "/reports/payments",
    component: PaymentGatewayReport,
    pageTitle: "Payment Gateway Report",
    permissionKey: "PAYMENT REPORT",
  },
  {
    path: "/reports/courier",
    component: CourierReport,
    pageTitle: "Courier Report",
    permissionKey: "COURIER REPORT",
  },
];

const breadcrumbParents = {
  "/admin/edit": { label: "Staff List", to: "/staff" },
  "/addAdmin": { label: "Staff List", to: "/staff" },
  "/staff/add": { label: "Staff List", to: "/staff" },
  "/staff/edit": { label: "Staff List", to: "/staff" },
  "/staff/edit/:staffId": { label: "Staff List", to: "/staff" },
  "/staff/view/:staffId": { label: "Staff List", to: "/staff" },
  "/category/add": { label: "Category List", to: "/categories" },
  "/category/edit/:slug": { label: "Category List", to: "/categories" },
  "/category/view/:slug": { label: "Category List", to: "/categories" },
  "/product/add": { label: "Product List", to: "/products" },
  "/product/stock-adjust": { label: "Product List", to: "/products" },
  "/product/add-stock": { label: "Product List", to: "/products" },
  "/product/edit/:slug": { label: "Product List", to: "/products" },
  "/product/view/:slug": { label: "Product List", to: "/products" },
  "/product/import": { label: "Product List", to: "/products" },
  "/menu/add": { label: "Menu List", to: "/menu" },
  "/menu/edit/:id": { label: "Menu List", to: "/menu" },
  "/menu/view/:id": { label: "Menu List", to: "/menu" },
  "/tax/add": { label: "Tax List", to: "/tax" },
  "/tax/edit": { label: "Tax List", to: "/tax" },
  "/tax/view/:id": { label: "Tax List", to: "/tax" },
  "/tax/delete": { label: "Tax List", to: "/tax" },
  "/size/add": { label: "Size List", to: "/size" },
  "/size/edit/:id": { label: "Size List", to: "/size" },
  "/size/view/:id": { label: "Size List", to: "/size" },
  "/material/add": { label: "Material List", to: "/material" },
  "/material/edit/:id": { label: "Material List", to: "/material" },
  "/material/view/:id": { label: "Material List", to: "/material" },
  "/font/add": { label: "Font List", to: "/font" },
  "/font/edit/:id": { label: "Font List", to: "/font" },
  "/font/view": { label: "Font List", to: "/font" },
  "/color/add": { label: "Color List", to: "/color" },
  "/color/edit/:id": { label: "Color List", to: "/color" },
  "/color/view/:id": { label: "Color List", to: "/color" },
  "/users/admin/view/:id": { label: "Users", to: "/users" },
  "/coupon/add": { label: "Coupon List", to: "/coupon" },
  "/coupon/edit/:id": { label: "Coupon List", to: "/coupon" },
  "/coupon/view/:id": { label: "Coupon List", to: "/coupon" },
  "/bulk-order/view/": { label: "Bulk Order List", to: "/bulk-order" },
  "/orders/view": { label: "Orders List", to: "/orders-list" },
  "/orders/verify": { label: "Orders List", to: "/orders-list" },
  "/approvedTestimonial": { label: "Testimonial List", to: "/testimonial" },
  "/blog/add": { label: "Blog", to: "/blog" },
  "/blog/edit/:id": { label: "Blog", to: "/blog" },
  "/blog/view/:slug": { label: "Blog", to: "/blog" },
  "/blogcategory/add": { label: "Blog Category", to: "/blogcategory" },
  "/blogcategory/edit/:id": { label: "Blog Category", to: "/blogcategory" },
  "/blogcategory/view/:slug": { label: "Blog Category", to: "/blogcategory" },
  "/banner-templates/add": { label: "Banner Templates", to: "/banner-template" },
  "/banner-templates/edit": { label: "Banner Templates", to: "/banner-template" },
  "/add-banner-template": { label: "Banner Templates", to: "/banner-template" },
  "/role/add": { label: "Role List", to: "/role-list" },
  "/role-edit/:id": { label: "Role List", to: "/role-list" },
  "/role-view/:id": { label: "Role List", to: "/role-list" },
};

const AppRouts = routeDefinitions.map((route) => {
  const parent = breadcrumbParents[route.path];
  const reports = route.path.startsWith("/reports/");
  return { ...route, breadcrumbs: parent ? [parent] : reports ? [{ label: "Reports" }] : [] };
});

export default AppRouts;
